import { render, staticRenderFns } from "./PrimaryFiltersVT.vue?vue&type=template&id=6531b67a&scoped=true"
import script from "./PrimaryFiltersVT.vue?vue&type=script&lang=js"
export * from "./PrimaryFiltersVT.vue?vue&type=script&lang=js"
import style0 from "./PrimaryFiltersVT.vue?vue&type=style&index=0&id=6531b67a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6531b67a",
  null
  
)

export default component.exports